<template>
  <div id="appContainer">
    <div class="mui-card">
      <div class="mui-card-header">
        {{ childBuildDetail.building.name }}
      </div>
      <div class="mui-card-content">
        <div class="mui-card-content-inner">
          {{ childBuildDetail.building.address }}
          <br />
          {{ childBuildDetail.building.buildingtype_text }}
          <div class="mui-card-content-inner-img">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in childBuildDetail.devicelist"
              :key="index"
            />
          </div>
        </div>
      </div>
      <div class="mui-card-footer">
        采集人：
        <div class="contribute">
          <span v-if="childBuildDetail.currentlist.length == 0"
            >暂无采集人</span
          >
          <span
            v-for="(item, index) in childBuildDetail.currentlist"
            :key="index"
            v-else
          >
            <span v-if="index !== 0">、</span>{{ item.username }}
          </span>
        </div>
      </div>
    </div>

    <div class="mui-card switch-box">
      <div class="switch-box-left">此建筑是否允许进入且能够进行设施的采集</div>
      <div class="switch-box-right">
        <mt-switch v-model="value" @change="turn"
          ><span v-if="value">是</span><span v-else>否</span></mt-switch
        >
      </div>
    </div>
    <div class="mui-card" v-show="value">
      <ul class="mui-table-view mui-table-view-chevron">
        <li
          class="mui-table-view-cell mui-media mui-collapse"
          v-for="(item, index) in childBuildDetail.devicelist"
          :key="index"
          :class="{ 'mui-active': facilitiesIndex == index }"
        >
          <a class="mui-navigate-right" @click.prevent="handleClick(index)">
            <img
              class="mui-pull-left"
              v-if="item.image !== ''"
              :src="item.image"
            />
            <img
              class="mui-pull-left"
              src="/static/images/facilities4.png"
              v-else
            />
            <div class="mui-media-body">
              <div class="mui-media-body-left">
                {{ item.name }}
                <span
                  class="mui-icon mui-icon-help"
                  v-if="item.id == 8"
                  @click.stop="showFacilitiesMessageMethod(index)"
                ></span>
                <span
                  v-if="
                    item.statuslist.audit +
                      item.statuslist.pass +
                      item.statuslist.reject ==
                    0
                  "
                  >(未采集)</span
                >
                <span v-else>(已采集)</span>
              </div>
              <div class="mui-media-body-right">
                <span class="mui-badge mui-badge-success">{{
                  item.statuslist.pass
                }}</span>
                <span class="mui-badge mui-badge-primary">{{
                  item.statuslist.audit
                }}</span>
                <span class="mui-badge mui-badge-danger">{{
                  item.statuslist.reject
                }}</span>
                {{ item.status }}
              </div>
            </div>
          </a>
          <ul class="mui-table-view mui-table-view-chevron">
            <!--          <ul v-else class="mui-table-view mui-table-view-chevron">-->

            <li
              style="
                width: 100%;
                display: flex;
                justify-content: space-around;
                align-items: center;
              "
              v-if="item.id !== 9 && item.id !== 18 && item.id !== 4"
            >
              <button
                class="mui-btn mui-btn-warning"
                style="
                  width: 42%;
                  margin: 3%;
                  display: inline-block;
                  float: left;
                "
                v-if="nullStatus == 0"
                @click="submitpostdata(index, item.id, -1)"
              >
                无此类型设施
              </button>
              <button
                class="mui-btn mui-btn-warning"
                style="
                  width: 42%;
                  margin: 3%;
                  display: inline-block;
                  float: left;
                "
                v-else
                disabled="disabled"
              >
                无此类型设施
              </button>
              <router-link
                class="mui-btn mui-btn-primary"
                style="width: 42%; margin: 3%; display: inline-block"
                :to="
                  '/facilities/Facilities_' +
                  item.id +
                  '/1/' +
                  task_id +
                  '/' +
                  childBuildingId +
                  '/' +
                  item.id +
                  '/0'
                "
                >添加此设施</router-link
              >
            </li>
            <li style="width: 100%" v-else-if="item.id == 18">
              <router-link
                class="mui-btn mui-btn-primary"
                style="width: 94%; margin: 3%; display: inline-block"
                :to="
                  '/facilities/Facilities_' +
                  item.id +
                  '/1/' +
                  task_id +
                  '/' +
                  childBuildingId +
                  '/' +
                  item.id +
                  '/0'
                "
                >添加此设施</router-link
              >
            </li>
            <li
              v-else
              style="
                width: 100%;
                display: flex;
                justify-content: space-around;
                align-items: center;
              "
            >
              <button
                class="mui-btn mui-btn-warning"
                style="
                  width: 42%;
                  margin: 5%;
                  display: inline-block;
                  float: left;
                "
                v-if="nullStatus - 0 !== -1"
                @click="submitpostdata(index, item.id, -1)"
              >
                无此类型设施
              </button>
              <button
                class="mui-btn mui-btn-warning"
                style="
                  width: 42%;
                  margin: 5%;
                  display: inline-block;
                  float: left;
                "
                v-else
                disabled="disabled"
              >
                无此类型设施
              </button>
              <button
                class="mui-btn mui-btn-primary"
                style="
                  width: 42%;
                  margin: 5%;
                  display: inline-block;
                  float: left;
                "
                v-if="nullStatus - 0 !== 1"
                @click="submitpostdata(index, item.id, 1)"
              >
                有此类型设施
              </button>
              <button
                class="mui-btn mui-btn-primary"
                style="
                  width: 42%;
                  margin: 5%;
                  display: inline-block;
                  float: left;
                "
                v-else
                disabled="disabled"
              >
                有此类型设施
              </button>
            </li>
          </ul>
          <!--          <ul v-if="item.statuslist.audit + item.statuslist.pass + item.statuslist.reject != 0 && item.id !== 9" class="mui-table-view mui-table-view-chevron">-->
          <ul class="mui-table-view mui-table-view-chevron">
            <li
              class="mui-table-view-cell mui-media"
              v-for="(postItem, postIndex) in item.postlist"
              :key="postIndex"
            >
              <a class="mui-navigate-right">
                <div class="mui-media-body">
                  <div
                    class="mui-media-body-left"
                    style="width: calc(100% - 150px)"
                    :style="postItem.user_id - 0 == uid - 0?'':'width: calc(100% - 20px)'"
                  >
                    <span
                      v-if="postItem.status == '0'"
                      class="mui-badge mui-badge-primary"
                      >(待审核)</span
                    >
                    <span
                      v-if="postItem.status == '1'"
                      class="mui-badge mui-badge-success"
                      >(已通过)</span
                    >
                    <span
                      v-if="postItem.status == '2'"
                      class="mui-badge mui-badge-danger"
                      >(已驳回)</span
                    >

                    <span
                      v-if="postItem.name === '1' || postItem.name === '-1'"
                    >
                      {{ postItem.name_ }}
                    </span>
                    <span v-else>
                      {{ postItem.name }}
                    </span>
                  </div>
                  <div class="mui-media-body-right" style="width: 150px">
                    <template
                      v-if="postItem.name !== '1' && postItem.name !== '-1'"
                    >
                      <router-link
                        :to="
                          '/facilities/Facilities_' +
                          postItem.buildingdevicetype_id +
                          '/2/' +
                          task_id +
                          '/' +
                          childBuildingId +
                          '/' +
                          postItem.buildingdevicetype_id +
                          '/' +
                          postItem.id
                        "
                        class="mui-btn mui-btn-primary mui-btn-outlined"
                        v-if="postItem.user_id - 0 == uid - 0"
                        >查看</router-link
                      >
                      <router-link
                        :to="
                          '/facilities/Facilities_' +
                          postItem.buildingdevicetype_id +
                          '/3/' +
                          task_id +
                          '/' +
                          childBuildingId +
                          '/' +
                          postItem.buildingdevicetype_id +
                          '/' +
                          postItem.id
                        "
                        class="mui-btn mui-btn-success mui-btn-outlined"
                        v-if="
                          postItem.user_id - 0 == uid - 0 &&
                          postItem.status - 0 !== 1
                        "
                        >编辑</router-link
                      >
                    </template>
                    <button
                      class="mui-btn mui-btn-danger mui-btn-outlined"
                      v-if="
                        postItem.user_id - 0 == uid - 0 &&
                        postItem.status - 0 !== 1
                      "
                      @click.prevent="
                        deletePostData(
                          index,
                          postIndex,
                          postItem.status,
                          postItem.id
                        )
                      "
                    >
                      删除
                    </button>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="mui-card" id="add-button">
      <button
        type="button"
        class="mui-btn mui-btn-primary"
        style="color: #fff;!important;"
        v-show="value"
        v-if="showCard"
        @click="isShowPopup()"
      >
        开始采集
      </button>
    </div>
    <mt-popup
      v-model="showPopup"
      position="bottom"
      type="ios"
      pop-transition="popup-fade"
      title="请选择要采集的建筑"
      v-show="showPopup"
    >
      <div class="mui-card" style="width: 100%">
        <div class="mui-card-header">请选择要采集设施类型</div>
        <ul class="mui-table-view">
          <li
            class="mui-table-view-cell"
            v-for="(item, index) in childBuildDetail.devicelist"
            :key="index"
          >
            <router-link
              :to="
                '/facilities/Facilities_' +
                item.id +
                '/1/' +
                task_id +
                '/' +
                childBuildingId +
                '/' +
                item.id +
                '/0'
              "
              class="mui-navigate-right"
              v-if="item.id !== 9"
            >
              {{ item.name }}
            </router-link>
            <span v-else @click="submitpostdata(index, item.id, 1)">
              {{ item.name }}
            </span>
          </li>
        </ul>
      </div>
    </mt-popup>
    <mt-popup
      v-model="showFacilitiesMessage"
      type="ios"
      pop-transition="popup-fade"
      v-show="showFacilitiesMessage"
      style="width: 80%; border-radius: 5%"
    >
      <facilities-introduce
        :name="FacilitiesMessageTitle"
        :facilitiesType="FacilitiesMessageType"
      ></facilities-introduce>
    </mt-popup>
  </div>
</template>

<script>
import { MessageBox, Toast } from "mint-ui";
import facilitiesIntroduce from "../Facilities/facilitiesIntroduce";
export default {
  name: "BuildDetail",
  data() {
    return {
      value: true,
      showCard: false,
      showPopup: false,
      facilitiesIndex: -1,
      showFacilitiesMessage: false,
      FacilitiesMessageTitle: "",
      FacilitiesMessageType: "",
      uid: window.localStorage.getItem("uid"),
      childBuildDetail: {
      //   task_id: 8,
      //   building: {
      //     id: 1272,
      //     name: "测试二级建筑物2",
      //     buildingtype_id: 16,
      //     province: "江苏",
      //     city: "苏州",
      //     area: "虎丘",
      //     address: "32323",
      //     lng: "120.548404",
      //     lat: "31.295191",
      //     createtime: 1615514283,
      //     levellist: "2",
      //     updatetime: 1615514283,
      //     remark: null,
      //     admin_id: 9,
      //     score: 5,
      //     building_id: 1271,
      //     deletetime: null,
      //     weigh: 1272,
      //     levellist_text: "Levellist 2",
      //     buildingtype_text: "会展中心/博览中心/科技馆/艺术馆",
      //     childbuildinglist: [],
      //     buildingimg: null,
      //   },
      //   devicelist: [
      //     {
      //       id: 6,
      //       name: "低位接待台",
      //       image:
      //         "https://onbotics-map.oss-cn-shanghai.aliyuncs.com/public/bc51f64827a991c259a55e6b4dd3d684.png",
      //       postlist: [],
      //       statuslist: {
      //         audit: 0,
      //         pass: 0,
      //         reject: 0,
      //       },
      //     },
      //     {
      //       id: 7,
      //       name: "无障碍停车位",
      //       image:
      //         "https://onbotics-map.oss-cn-shanghai.aliyuncs.com/public/2fdbb7b766dff31d2f9f2f89fe418397.png",
      //       postlist: [
      //         {
      //           id: 3,
      //           name: "测试",
      //           task_id: 8,
      //           building_id: 1272,
      //           buildingdevicetype_id: 7,
      //           score: 5,
      //           positiondesc: null,
      //           desc: "12112",
      //           devicedesc: null,
      //           images: "",
      //           lng: "",
      //           lat: "",
      //           createtime: 1615965770,
      //           updatetime: 1615965770,
      //           user_id: 3,
      //           admin_id: null,
      //           remark: "",
      //           deletetime: null,
      //           status: "1",
      //           status_text: "Status 1",
      //         },
      //       ],
      //       statuslist: {
      //         audit: 0,
      //         pass: 1,
      //         reject: 0,
      //       },
      //     },
      //     {
      //       id: 3,
      //       name: "无障碍席位",
      //       image:
      //         "https://onbotics-map.oss-cn-shanghai.aliyuncs.com/public/aced8aa131f3fd3cb25e298c9d40bac7.png",
      //       postlist: [],
      //       statuslist: {
      //         audit: 0,
      //         pass: 0,
      //         reject: 0,
      //       },
      //     },
      //     {
      //       id: 8,
      //       name: "无障碍电梯",
      //       image:
      //         "https://onbotics-map.oss-cn-shanghai.aliyuncs.com/public/a9e2754f208d7612321c8fc0a2d561c4.png",
      //       postlist: [],
      //       statuslist: {
      //         audit: 0,
      //         pass: 0,
      //         reject: 0,
      //       },
      //     },
      //   ],
      //   currentlist: [],
      },
      childBuildingId: this.$route.params.childId,
      task_id: this.$route.params.taskId,
      nullStatus: 0,
      isJoin: 0,
      task_info: [],
      currentPosi: [], //当前位置坐标
    };
  },
  created() {
    setTimeout(() => {
      this.showCard = true;
    }, 530);

    // this.getData(this, this.currentPosi);

    // console.log(this.uid)
    // alert(this.uid)
    this.getChildBuildingInfo();
  },

  methods: {
    turn: function () {
      console.log(this.value);
      var isAccessible = "1";
      if (this.value) {
        isAccessible = "1";
      } else {
        isAccessible = "0";
      }
      this.$http
        .get(
          "api/gather/ifexist?building_id=" +
            this.childBuildingId +
            "&isaccessible=" +
            isAccessible
        )
        .then(function (data) {
          if (data.body.code == 1) {
          } else {
            Toast(data.body.msg);
          }
        });
    },
    handleClick(index) {
      // 先判断是否有加入该任务，没有则给提示框提示先加入
      if (this.isJoin == "0") {
        this.joinTask();
        return false;
      }

      if (
        this.childBuildDetail.devicelist[index].statuslist.audit +
          this.childBuildDetail.devicelist[index].statuslist.pass +
          this.childBuildDetail.devicelist[index].statuslist.reject ==
        0
      ) {
        this.CheakDeviceIsNull(
          this.childBuildDetail.devicelist[index].id,
          index
        );
      }
      if (this.facilitiesIndex == index) {
        this.facilitiesIndex = -1;
      } else {
        this.facilitiesIndex = index;
      }
    },
    showFacilitiesMessageMethod(index) {
      this.showFacilitiesMessage = !this.showFacilitiesMessage;
      this.FacilitiesMessageTitle =
        this.childBuildDetail.devicelist[index].name;
      this.FacilitiesMessageType = this.childBuildDetail.devicelist[index].id;
    },
    getChildBuildingInfo() {
      this.$http
        .get("api/gather/getChildBuildingInfo?id=" + this.childBuildingId)
        .then(function (data) {
          if (data.body.code == 1) {
            if (data.body.data.list.building.isaccessible == "0") {
              this.value = false;
            } else if (data.body.data.list.building.isaccessible == "1") {
              this.value = true;
            }
            data.body.data.list.devicelist.forEach((item, index) => {
              if (item.image == "") {
                data.body.data.list.devicelist[index].image =
                  "/static/images/facilities4.png";
              }
            });
            data.body.data.list.currentlist.forEach((item, index) => {
              if (item.openid == window.localStorage.getItem("userOpenid")) {
                this.isJoin = 1;
              }
            });
            this.childBuildDetail = data.body.data.list;
            //console.log(this.childBuildDetail.devicelist)
          } else {
            Toast(data.body.data.msg);
          }
        });
    },
    CheakDeviceIsNull(devicetypeId, id) {
      this.$http
        .get(
          "api/gather/CheakDeviceIsNull?devicetype_id=" +
            devicetypeId +
            "&building_id=" +
            this.childBuildingId +
            "&task_id=" +
            this.task_id
        )
        .then(function (data) {
          if (data.body.code == 0) {
            this.nullStatus = 0;
          } else {
            this.nullStatus = data.body.data.list.name;
          }
        });
    },
    submitpostdata(devicetypeId, id, type) {
      this.$http
        .post(
          "api/gather/submitpostdata",
          {
            name: type,
            task_id: this.task_id,
            building_id: this.childBuildingId,
            buildingdevicetype_id:
              this.childBuildDetail.devicelist[devicetypeId].id,
            position: this.currentPosi,
          },
          { emulateJSON: true }
        )
        .then(function (data) {
          if (data.body.code == 1) {
            this.nullStatus = type;
            Toast("上传成功");
            this.getChildBuildingInfo();
          }
        });
    },
    deletePostData(devicelistId, postId, status, id) {
      MessageBox({
        title: "确认操作",
        message: "您确定要删除此数据吗",
        showCancelButton: true,
      }).then((action) => {
        if (action == "confirm") {
          this.$http
            .get("api/gather/delPostData?id=" + id)
            .then(function (data) {
              this.childBuildDetail.devicelist[devicelistId].postlist.splice(
                postId,
                1
              );
              if (status == "0") {
                this.childBuildDetail.devicelist[devicelistId].statuslist[
                  "audit"
                ] -= 1;
              } else {
                this.childBuildDetail.devicelist[devicelistId].statuslist[
                  "reject"
                ] -= 1;
              }
              Toast("删除成功");
            });
        }
      });
    },
    joinTask() {
      this.$http
        .get("api/gather/getTaskInfo?id=" + this.task_id)
        .then(function (data) {
          if (data.body.code == 1) {
            this.task_info = data.body.data.list;
          } else {
            Toast("此任务不存在");
          }
        });
      MessageBox({
        title: "尚未加入",
        message: "你尚未加入该区域任务吗？确认加入吗",
        showCancelButton: true,
      })
        .then((action) => {
          if (action == "confirm") {
            this.$http
              .get("api/gather/joinTask?task_id=" + this.task_info.id)
              .then((data) => {
                if (data.body.code == 1) {
                  this.isJoin = "1";
                  // this.childBuildDetail.currentlist.push({'username': '前端采集员'})
                  Toast("已加入该任务");
                  this.getChildBuildingInfo();
                } else {
                  Toast(data.body.msg);
                }
              });
          } else {
            this.isJoin = "0";
          }
        })
        .catch((error) => {
          if (error == "cancel") {
            this.isJoin = "0";
          }
        });
    },
    isShowPopup() {
      if (this.isJoin == 0) {
        this.joinTask();
        return false;
      } else {
        this.showPopup = !this.showPopup;
      }
    },
  },
  components: {
    facilitiesIntroduce,
  },
};
</script>
<style scoped lang="scss">
//建筑物是否可以采集的开关样式switch-box,switch-box-left,switch-box-right//
.switch-box {
  position: relative;
  height: 90px;
}
.switch-box-left {
  width: 150px;
  height: 44px;
  position: absolute;
  top: 23px;
  left: 15px;
}
.switch-box-right {
  width: 90px;
  height: 34px;
  position: absolute;
  top: 28px;
  right: 0;
}
.mui-card-footer img {
  width: 15%;
}

.mint-swipe {
  height: 178.5px;
  .mint-swipe-item {
    img {
      width: 100%;
    }
  }
}

.mui-table-view {
  .mui-table-view-cell {
    .mui-navigate-right {
      .mui-pull-left {
        padding: 3px;
        width: 30px;
        padding-top: 10px;
      }
      .mui-media-body {
        .mui-media-body-left {
          width: 70%;
          float: left;
          margin-top: 10px;
        }
        .mui-media-body-right {
          width: 30%;
          font-size: 14px;
          text-align: center;
          display: inline-block;
          margin-top: 10px;
          button {
            width: 33%;
          }
        }
      }
    }
    .mui-table-view {
      .mui-table-view-cell {
        .mui-navigate-right {
          .mui-media-body {
            .mui-media-body-left {
              width: 55%;
              font-size: 14px;
              line-height: 20px;
              margin-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .mui-media-body-right {
              width: 40%;
              margin-top: 5px;
              text-align: left;
              .mui-btn {
                font-size: 14px;
                padding: 3px;
              }
            }
          }
        }
      }
    }
  }
}
.mui-table-view-chevron .mui-table-view-cell {
  padding-right: 57px;
}

#add-button {
  width: 95%;
  position: fixed;
  left: 0;
  bottom: 5px;

  .mui-btn {
    width: 100%;
  }
}

#appContainer {
  margin-bottom: 120px;
}

.mui-card-header {
  display: block;
  text-align: center;
}
.mui-card-content {
  .mui-card-content-inner {
    .mui-card-content-inner-img {
      width: 100%;
      padding-top: 10px;
      img {
        display: inline-block;
        padding-left: 5px;
        width: 25px;
      }
    }
  }
}

.mint-popup,
.mint-popup-bottom {
  width: 100%;
}

.facilitiesPopus {
  .mui-card {
    .mui-table-view {
      .mui-table-view-cell {
        .mui-media-body {
          .mui-media-body-left {
            width: 45%;
            float: left;
            font-size: 14px;
            line-height: 26px;
            padding-top: 5px;
          }
          .mui-media-body-right {
            width: 55%;
            display: inline-block;
            padding-top: 5px;
            font-size: 14px;
            .mui-btn {
              width: 30%;
              font-size: 15px;
              padding: 3px 6px;
              display: block;
            }
          }
        }
      }
    }
  }
}

.mui-table-view-cell.mui-active {
  background-color: #ccc;
}

.mui-icon-help {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Build/BuildDetail.vue